import { from, Observable, of, throwError } from 'rxjs';

export const normalizeAndHash = (value: string): Observable<string> => {
  if (typeof value !== 'string') {
    return throwError(() => new TypeError('Value must be a string.'));
  }
  if (value.trim() === '') {
    return of('');
  }
  const normalized = value.trim().toLowerCase();

  const sha256Hex = async (input: string): Promise<string> => {
    if (typeof globalThis.crypto?.subtle === 'undefined') {
      throw new Error('Web Crypto (crypto.subtle) is unavailable in this environment.');
    }
    const data = new TextEncoder().encode(input);
    const digest = await globalThis.crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(digest))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  };

  return from(sha256Hex(normalized));
};
